<tabset
  class="nav nav-tabs admin-tab cs-primary-tabs cs-reports-primary-tabs"
  #reportsTab
>
  <tab
    *ngIf="hasManageReportPermission && hasRunReportPermission"
    class="padding0"
    id="reports"
    (select)="selectTab(reportTab.REPORT)"
    [active]="activeTab === reportTab.REPORT"
    heading="{{ 'customer-service.Reports' | translate | translateKey }}"
  >
    <div class="container">
      <ng-container *ngTemplateOutlet="reports"> </ng-container>
    </div>
  </tab>
  <tab
    *ngIf="hasManageReportPermission && hasInvoicePrintingPermission"
    class="padding0"
    id="invoice-printing"
    (select)="selectTab(reportTab.INVOICE_PRINTING)"
    [active]="activeTab === reportTab.INVOICE_PRINTING"
    heading="{{
      'customer-service.Invoice Printing' | translate | translateKey
    }}"
    class="invoice-tabset"
  >
    <div class="container invoice-container">
      <app-invoice-report></app-invoice-report>
    </div>
  </tab>
</tabset>

<ng-template #reports>
  <div class="row padding0">
    <div id="container" class="col-md-12">
      <div id="reports-container">
        <div *ngIf="reportsForm">
          <form [formGroup]="reportsForm">
            <div class="row no-margin">
              <div class="col-md-6 col-xs-5 padding0">
                <label
                  for="operatingCountry"
                  class="control-label col-xs-3 padding0"
                  >{{
                    "reports.Operating Country" | translate | translateKey
                  }}</label
                >
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="operatingCountry"
                    class="form-control"
                    (change)="onOperatingCountryChange($event.target.value)"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option
                      *ngFor="
                        let country of operatingCountries | orderBy: 'name'
                      "
                      [value]="country.id"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['operatingCountry'].valid &&
                      reportsForm.controls['operatingCountry'].touched
                    "
                  >
                    {{
                      "reports.Please select operating country to proceed further"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>

              <!-- no longer user -->
              <!-- <div class="col-md-6 col-xs-5 padding0">
                <label for="store" class="control-label col-xs-3 padding0">{{
                  "reports.Store" | translate | translateKey
                }}</label>
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="store"
                    class="form-control"
                    (change)="onStoreChange($event.target.value)"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option
                      *ngFor="let store of stores"
                      [value]="store.countryId"
                    >
                      {{ store.name }}
                    </option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['store'].valid &&
                      reportsForm.controls['store'].touched
                    "
                  >
                    {{
                      "reports.Please select store to proceed further"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div> -->

              <!-- multi selector for store -->
              <div class="col-md-6 col-xs-5 padding0">
                <label for="store" class="control-label col-xs-3 padding0">{{
                  "reports.Store" | translate | translateKey
                }}</label>
                <!-- multiselect -->
                <div class="col-xs-7 floating-input">
                  <angular2-multiselect
                    formControlName="store"
                    [data]="dropdownList"
                    [(ngModel)]="selectedItems"
                    [settings]="dropdownSettings"
                    (onSelect)="onItemSelect($event)"
                    (onDeSelect)="OnItemDeSelect($event)"
                    (onSelectAll)="onSelectAll($event)"
                    (onDeSelectAll)="onDeSelectAll($event)"
                  ></angular2-multiselect>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['store'].valid &&
                      reportsForm.controls['store'].touched
                    "
                  >
                    {{
                      "reports.Please select store to proceed further"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
                <!--  -->
              </div>
            </div>
            <div class="row no-margin">
              <div class="col-md-6 col-xs-5 padding0">
                <label
                  for="reportCategory"
                  class="control-label col-xs-3 padding0"
                  >{{
                    "reports.Report Category" | translate | translateKey
                  }}</label
                >
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="reportCategory"
                    class="form-control"
                    (change)="onReportCategoryChange($event.target.value)"
                    [disabled]="!storeId"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option
                      *ngFor="let reportCategory of reportCategories"
                      [value]="reportCategory.id"
                    >
                      {{ reportCategory.value }}
                    </option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['reportCategory'].valid &&
                      reportsForm.controls['reportCategory'].touched
                    "
                  >
                    {{
                      "reports.Please select report category to proceed further"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xs-5 padding0">
                <label
                  for="subCategory"
                  class="control-label col-xs-3 padding0"
                  >{{
                    "customer-service.Reports" | translate | translateKey
                  }}</label
                >
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="subCategory"
                    class="form-control"
                    (change)="subCategoryChanged()"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option
                      *ngFor="let report of subReports"
                      [value]="report.reportName"
                    >
                      {{ report.reportName }}
                    </option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['subCategory'].valid &&
                      reportsForm.controls['subCategory'].touched
                    "
                  >
                    {{
                      "reports.Please select report to proceed further"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="subCategoryConstants.EnrollmentReport === reportsForm.controls.subCategory.value"  class="row no-margin">
              <div class="col-md-6 col-xs-5 padding0">
                <label for="email" class="control-label col-xs-3 padding0">
                  {{"reports.Email" | translate | translateKey}}
                </label>
                <div class="col-xs-7 floating-input">
                  <input id="email"  class="form-control"  pattern="^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$" placeholder="{{'reports.Email' | translate | translateKey}}" 
                       type="text"  formControlName="email" (change)="formValuesChanged()">
                  <div class="alert-msg" *ngIf="!reportsForm.controls['email'].valid && reportsForm.controls['email'].touched && reportsForm.controls['email'].hasError('pattern')">
                    {{"validation-message.Enter valid Email" | translate | translateKey}}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xs-5 padding0">
                <label for="fboId" class="control-label col-xs-3 padding0">
                  {{"reports.FBO ID" | translate | translateKey}}
                </label>
                <div class="col-xs-7 floating-input floatLabelContainer">
                  <input id="fboId"  class="form-control" placeholder="{{'reports.FBO ID' | translate | translateKey}}" 
                      type="text"  formControlName="fboId" (change)="formValuesChanged()" mask="000-000-000-000" minlength="12">
                  <div class="alert-msg" *ngIf="!reportsForm.controls['fboId'].valid &&  reportsForm.controls['fboId'].touched && reportsForm.controls['fboId'].hasError('minlength')">
                      {{"validation-message.Enter valid FBO ID" | translate | translateKey}}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row no-margin"
              *ngIf="
                reportsForm.controls['reportCategory'].value ==
                reportsCategoryEnum.POS
              "
            >
              <div class="col-md-6 col-xs-5 padding0">
                <label
                  for="posLocationId"
                  class="control-label col-xs-3 padding0"
                  >{{
                    "reports.POS Location" | translate | translateKey
                  }}</label
                >
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="posLocationId"
                    class="form-control"
                    (change)="formValuesChanged()"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option
                      *ngFor="let posLocation of posLocations"
                      [value]="posLocation.id"
                    >
                      {{ posLocation.name }}
                    </option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['posLocationId'].valid &&
                      reportsForm.controls['posLocationId'].touched
                    "
                  >
                    {{
                      "reports.Please select POS location"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xs-5 padding0" *ngIf="subCategoryConstants.POSEODOrderSummary === reportsForm.controls.subCategory.value">
                <label for="notesCheckBox" class="control-label col-xs-3 padding0">{{ "reports.Include Notes in Reports" | translate | translateKey }}</label>
                <div class="col-xs-7 floating-input">
                    <input id="notesCheckBox" role="checkbox" type="checkbox" class="check-box" formControlName="notesRequired">
                    <span class="verified">{{"reports.Note"  | translate | translateKey }}: </span>
                    <span class="verified">{{"reports.Including notes field in reports might take longer and/or may time out"| translate | translateKey }}</span>
                  </div>
              </div>
            </div>
<!-- previous Status and new Status drop downs -->
            <div *ngIf="subCategoryConstants.AccountStatusChange === reportsForm.controls.subCategory.value" class="row no-margin">
              <div class="col-md-6 col-xs-5 padding0">
                <label for="period" class="control-label col-xs-3 padding0"
                  >Previous Status</label
                >
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="previousStatus"
                    class="form-control"
                    (change)="formValuesChanged()"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option
                    *ngFor="let status of memberStatus"
                    [value]="status.id"
                  >
                    {{ status.value }}
                  </option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['previousStatus'].valid &&
                      reportsForm.controls['previousStatus'].touched
                    "
                  >
                    {{
                      "reports.Please select Previous Status"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-xs-5 padding0">
                <label for="period" class="control-label col-xs-3 padding0"
                  >New Status</label
                >
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="newStatus"
                    class="form-control"
                    (change)="formValuesChanged()"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option
                    *ngFor="let status of memberStatus"
                    [value]="status.id"
                  >
                    {{ status.value }}
                  </option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['newStatus'].valid &&
                      reportsForm.controls['newStatus'].touched
                    "
                  >
                    {{
                      "reports.Please select New Status"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>
            </div>


            <!-- *ngIf="
                reportsForm.controls['reportCategory'].value ==
                reportsCategoryEnum.Order
              " -->
            <div class="row no-margin">
              <div class="col-md-6 col-xs-5 padding0">
                <label for="period" class="control-label col-xs-3 padding0"
                  >Period</label
                >
                <div class="col-xs-7 floating-input">
                  <select
                    formControlName="period"
                    class="form-control"
                    (change)="formValuesChanged()"
                  >
                    <option value="" [selected]="true" disabled>
                      --{{ "reports.Select" | translate | translateKey }}--
                    </option>
                    <option value="101">Current Month</option>
                    <option value="102">Previous Month</option>
                    <option value="103">Custom Dates</option>
                  </select>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['period'].valid &&
                      reportsForm.controls['period'].touched
                    "
                  >
                    {{
                      "reports.Please select Period"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row no-margin"
              *ngIf="reportsForm.controls['period'].value == 103"
            >
              <div class="col-md-6 col-xs-5 padding0">
                <label for="fromDate" class="control-label col-xs-3 padding0">{{
                  "reports.From Date" | translate | translateKey
                }}</label>
                <div class="col-xs-7 floating-input floatLabelContainer">
                  <input
                    [owlDateTime]="dt3"
                    class="form-control"
                    placeholder="{{
                      'reports.dd-mmm-yyyy' | translate | translateKey
                    }}"
                    appRestrictSpecialCharacters
                    tabindex="0"
                    maxlength="11"
                    float-label
                    DateFormat
                    [min]="minDateRangeForDatePicker"
                    [max]="currentDate"
                    formControlName="fromDate"
                    [(ngModel)]="fromDate"
                    (dateTimeChange)="fromDateChange()"
                    (keypress)="fromDateChange()"
                  />
                  <owl-date-time
                    [pickerType]="'calendar'"
                    panelClass="'calendar-panel'"
                    #dt3
                  >
                  </owl-date-time>
                  <span
                    [owlDateTimeTrigger]="dt3"
                    class="fa fa-calendar calendar-icon select-pointer"
                  ></span>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['fromDate'].valid &&
                      reportsForm.controls['fromDate'].hasError('required') &&
                      (reportsForm.controls['fromDate'].touched || isSubmitted)
                    "
                  >
                    {{
                      "reports.Please select from date to get report"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['fromDate'].valid &&
                      reportsForm.controls['fromDate'].hasError(
                        'dateValidation'
                      ) &&
                      !reportsForm.controls['fromDate'].hasError('required')
                    "
                  >
                    {{
                      "reports.Please enter valid date"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['fromDate'].valid &&
                      reportsForm.controls['fromDate'].hasError(
                        'fromDateValidation'
                      )
                    "
                  >
                    {{
                      "reports.From date is greater than the to date"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['fromDate'].valid &&
                      reportsForm.controls['fromDate'].hasError(
                        'monthRangeValidation'
                      )
                    "
                  >
                    {{
                      "reports.Please enter the date range with duration of " +
                        dateRangeDuration +
                        " month(s)"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['fromDate'].valid &&
                      reportsForm.controls['fromDate'].hasError(
                        'dayRangeValidation'
                      )
                    "
                  >
                    {{
                      "reports.Please enter the date range for one day"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xs-5 padding0">
                <label for="toDate" class="control-label col-xs-3 padding0">{{
                  "reports.To Date" | translate | translateKey
                }}</label>
                <div class="col-xs-7 floating-input floatLabelContainer">
                  <input
                    [owlDateTime]="dt4"
                    class="form-control"
                    placeholder="{{
                      'reports.dd-mmm-yyyy' | translate | translateKey
                    }}"
                    appRestrictSpecialCharacters
                    tabindex="0"
                    maxlength="11"
                    float-label
                    DateFormat
                    formControlName="toDate"
                    [(ngModel)]="toDate"
                    (dateTimeChange)="toDateChange()"
                    [min]="minDateRangeForDatePicker"
                    [max]="0"
                    (keypress)="toDateChange()"
                  />
                  <owl-date-time
                    [pickerType]="'calendar'"
                    panelClass="'calendar-panel'"
                    #dt4
                  >
                  </owl-date-time>
                  <span
                    [owlDateTimeTrigger]="dt4"
                    class="fa fa-calendar calendar-icon select-pointer"
                  ></span>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['toDate'].valid &&
                      reportsForm.controls['toDate'].hasError('required') &&
                      (reportsForm.controls['toDate'].touched || isSubmitted)
                    "
                  >
                    {{
                      "reports.Please select to date to get report"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['toDate'].valid &&
                      reportsForm.controls['toDate'].hasError(
                        'dateValidation'
                      ) &&
                      !reportsForm.controls['toDate'].hasError('required')
                    "
                  >
                    {{
                      "reports.Please enter valid date"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['toDate'].valid &&
                      reportsForm.controls['toDate'].hasError(
                        'toDateValidation'
                      )
                    "
                  >
                    {{
                      "reports.To date is lesser than the from Date"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['toDate'].valid &&
                      reportsForm.controls['toDate'].hasError(
                        'monthRangeValidation'
                      )
                    "
                  >
                    {{
                      "reports.Please enter the date range with duration of " +
                        dateRangeDuration +
                        " month(s)"
                        | translate
                        | translateKey
                    }}
                  </div>
                  <div
                    class="alert-msg"
                    *ngIf="
                      !reportsForm.controls['toDate'].valid &&
                      reportsForm.controls['toDate'].hasError(
                        'dayRangeValidation'
                      )
                    "
                  >
                    {{
                      "reports.Please enter the date range for one day"
                        | translate
                        | translateKey
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row no-margin float-right">
              <div class="col-md-12 padding0">
                <button
                  tabindex="0"
                  type="button"
                  (click)="onSubmitRunReport()"
                  class="btn blue-button"
                  [disabled]="isLoading || !reportsForm.valid"
                >
                  <span
                    >{{ "reports.RUN" | translate | translateKey }}
                    <i *ngIf="isLoading" class="fa fa-spinner fa-spin"></i>
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div
    class="row w-100 no-margin message paddingtop-20"
    *ngIf="!(reportsForm.valid && isSubmitted)"
  >
    <div class="w-100 messageContent text-center">
      <strong class="">{{
        "reports.Please click on run to get report(s)"
          | translate
          | translateKey
      }}</strong>
    </div>
  </div>
  <ng-container
    class="row"
    *ngIf="
      reportsForm.valid &&
      isSubmitted &&
      subCategoryConstants.POSEODOrderSummary ===
        reportsForm.controls.subCategory.value
    "
  >
    <app-pos-summary-reports
      [fromDate]="formattedFromDate"
      [toDate]="formattedToDate"
      [areaCode]="areaCode"
      [storeInfo]="storeInfo"
      [posLocationId]="reportsForm.controls['posLocationId'].value"
      (isLoadedData)="dataLoaded()"
      (addFavoriteEvent)="addToFavorite()"
      [paymentMethods]="posPaymentMethods"
      [notesRequired] = "reportsForm.controls['notesRequired'].value"
    >
    </app-pos-summary-reports>
  </ng-container>
  <ng-container
    class="row"
    *ngIf="
      reportsForm.valid &&
      isSubmitted &&
      subCategoryConstants.POSEasyShopSKUSales ===
        reportsForm.controls.subCategory.value
    "
  >
    <app-pos-product-sales-report
      [storeId]="finalStoreIds"
      [posLocationId]="reportsForm.controls['posLocationId'].value"
      [fromDate]="formattedFromDate"
      [toDate]="formattedToDate"
      (isLoadedData)="dataLoaded()"
      (addFavoriteEvent)="addToFavorite()"
    ></app-pos-product-sales-report>
  </ng-container>
  <ng-container
    class="row"
    *ngIf="
      reportsForm.valid &&
      isSubmitted &&
      subCategoryConstants.OrdersDashboard ===
        reportsForm.controls.subCategory.value
    "
  >
    <app-order-dashboard
      [storeId]="finalStoreIds"
      [fromDate]="formattedFromDate"
      [toDate]="formattedToDate"
      (isLoadedData)="dataLoaded()"
      [storeInfo]="storeInfo"
      (addFavoriteEvent)="addToFavorite()"
    ></app-order-dashboard>
  </ng-container>
  <ng-container
    class="row"
    *ngIf="
      reportsForm.valid &&
      isSubmitted &&
      subCategoryConstants.OrdersReport ===
        reportsForm.controls.subCategory.value
    "
  >
    <app-order-reports
      [storeId]="finalStoreIds"
      [fromDate]="formattedFromDate"
      [toDate]="formattedToDate"
      (isLoadedData)="dataLoaded()"
      [storeInfo]="storeInfo"
      (addFavoriteEvent)="addToFavorite()"
    ></app-order-reports>
  </ng-container>
  <!-- for bsn reports -->
  <ng-container
    class="row"
    *ngIf="
      reportsForm.valid &&
      isSubmitted &&
      subCategoryConstants.BSNReport ===
        reportsForm.controls.subCategory.value
    "
  >
    <app-bsn-reports
      [storeId]="countryIdForBsn"
      [countryName]="displayCountryName"
      [fromDate]="formattedFromDate"
      [toDate]="formattedToDate"
      (isLoadedData)="dataLoaded()"
      [storeInfo]="storeInfo"
      (addFavoriteEvent)="addToFavorite()"
    ></app-bsn-reports>
  </ng-container>
    <!-- for IBAN reports -->
  <ng-container
  class="row"
  *ngIf="
    reportsForm.valid &&
    isSubmitted &&
    subCategoryConstants.IBANReport ===
      reportsForm.controls.subCategory.value
  "
>
  <app-iban-reports
    [storeId]="countryIdForIBAN"
    [countryName]="displayCountryName"
    [fromDate]="formattedFromDate"
    [toDate]="formattedToDate"
    (isLoadedData)="dataLoaded()"
    [storeInfo]="storeInfo"
    (addFavoriteEvent)="addToFavorite()"
  ></app-iban-reports>
</ng-container>

<!-- for Account Status changes Reports -->
<ng-container
class="row"
*ngIf="reportsForm.valid && isSubmitted &&
  subCategoryConstants.AccountStatusChange === reportsForm.controls.subCategory.value">
<app-account-status-change-reports
[storeId]="finalStoreIds"
[fromDate]="formattedFromDate"
[toDate]="formattedToDate"
(isLoadedData)="dataLoaded()"
[storeInfo]="storeInfo"
[previousStatus]="previousStatus"
[newStatus]="newStatus"
></app-account-status-change-reports>
</ng-container>


<!-- for Enrollment report -->

<ng-container
class="row"
*ngIf="
  reportsForm.valid &&
  isSubmitted &&
  subCategoryConstants.EnrollmentReport === reportsForm.controls.subCategory.value
"
>
<app-enrollment-reports
  [storeId]="finalStoreIds"
  [fromDate]="formattedFromDate"
  [toDate]="formattedToDate"
  (isLoadedData)="dataLoaded()"
  [storeInfo]="storeInfo"
  [email] = "email"
  [fboId] = "fboId"
></app-enrollment-reports>
</ng-container>

</ng-template>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/reports.component.html